export default __webpack_public_path__ + "static/media/english-to-swedish-screenshot-02.1b8ed635.png";